<lib-prod-form [fields]="fields" [data]="data" (onSubmitEvent)="submit($event)" (passFormEvent)="onFormOutput($event)"></lib-prod-form>
